import { dispatch } from "hf-rt";

const initialState = {
  show: false
};

export default {
  name: "mobileMenu",
  actions: {
    showMobileMenu: function(bool) {
      dispatch({ type: "SHOW_MOBILE_MENU", bool });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "SHOW_MOBILE_MENU":
        return { ...state, show: action.bool };
      default:
        return state;
    }
  }
};
